<div class="file-tree-toolbar" [class.show-shadow]="state.scrolled">
  <div class="text-primary text-sm font-medium">{{ 'examdojo.entity.topics' | transloco | titlecase }}</div>

  <div class="flex items-center gap-x-2">
    <y42-asset-tree-toolbar-settings (badgeTypeChanged)="setBadgeType($event)" />
  </div>
</div>
